const scrollTo = function (target) {
    if (target != undefined && $(target).length > 0) {
        $('html, body').animate({
            easing : 'linear',
            scrollTop: $(target).offset().top
        }, 200);
    }

}


export {
    scrollTo
}